import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_chargeback_form",
  ref: "newChargebackModalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-750px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Insert Chargeback", -1)
const _hoisted_6 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_new_address_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_new_address_header",
  "data-kt-scroll-wrappers": "#kt_modal_new_address_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "notice d-flex mb-9 p-6" }
const _hoisted_11 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_12 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_13 = { class: "fw-bold" }
const _hoisted_14 = { class: "text-gray-800 fw-bolder" }
const _hoisted_15 = { class: "fs-6 text-gray-600" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Mid Number: ")
const _hoisted_17 = { class: "row mb-5" }
const _hoisted_18 = { class: "col-md-4 fv-row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Dispute Date", -1)
const _hoisted_20 = { class: "col-md-4 fv-row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Notice Date", -1)
const _hoisted_22 = { class: "col-md-4 fv-row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Due Date", -1)
const _hoisted_24 = { class: "col-md-4 fv-row" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Transaction Date", -1)
const _hoisted_26 = { class: "row g-9 mb-5" }
const _hoisted_27 = { class: "col-md-6 fv-row" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Case Number", -1)
const _hoisted_29 = { class: "fv-plugins-message-container" }
const _hoisted_30 = { class: "fv-help-block" }
const _hoisted_31 = { class: "col-md-6 fv-row" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "ARN/Reference Number", -1)
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = { class: "row mb-5" }
const _hoisted_36 = { class: "col-md-4 fv-row" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Card Brand", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("option", {
  label: "Visa",
  value: "Visa"
}, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("option", {
  label: "Mastercard",
  value: "Mastercard"
}, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("option", {
  label: "Discover",
  value: "Discover"
}, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("option", {
  label: "American Express",
  value: "American Express"
}, null, -1)
const _hoisted_42 = { class: "col-md-4 fv-row" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Card Bin", -1)
const _hoisted_44 = { class: "fv-plugins-message-container" }
const _hoisted_45 = { class: "fv-help-block" }
const _hoisted_46 = { class: "col-md-4 fv-row" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Card Last", -1)
const _hoisted_48 = { class: "fv-plugins-message-container" }
const _hoisted_49 = { class: "fv-help-block" }
const _hoisted_50 = { class: "row mb-5" }
const _hoisted_51 = { class: "col-md-4 fv-row" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Dispute Amount", -1)
const _hoisted_53 = { class: "fv-plugins-message-container" }
const _hoisted_54 = { class: "fv-help-block" }
const _hoisted_55 = { class: "col-md-4 fv-row" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Trans Amount", -1)
const _hoisted_57 = { class: "fv-plugins-message-container" }
const _hoisted_58 = { class: "fv-help-block" }
const _hoisted_59 = { class: "col-md-4 fv-row" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Reason Code", -1)
const _hoisted_61 = { class: "fv-plugins-message-container" }
const _hoisted_62 = { class: "fv-help-block" }
const _hoisted_63 = { class: "row g-9 mb-5" }
const _hoisted_64 = { class: "col-md-6 fv-row" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Auth Code", -1)
const _hoisted_66 = { class: "fv-plugins-message-container" }
const _hoisted_67 = { class: "fv-help-block" }
const _hoisted_68 = { class: "col-md-6 fv-row" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Reference ID", -1)
const _hoisted_70 = { class: "fv-plugins-message-container" }
const _hoisted_71 = { class: "fv-help-block" }
const _hoisted_72 = { class: "fv-row mb-5" }
const _hoisted_73 = { class: "d-flex flex-stack" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "me-5" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold" }, "Is this a Second / Escalated Dispute?"),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-7 fw-bold text-gray-400" }, " If you need more info, please contact your payment processor ")
], -1)
const _hoisted_75 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_76 = { class: "fv-plugins-message-container" }
const _hoisted_77 = { class: "fv-help-block" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold text-gray-400" }, " Yes ", -1)
const _hoisted_79 = { class: "fv-row pt-5 pb-5" }
const _hoisted_80 = {
  class: "dropzone",
  ref: "dropRef"
}
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "dz-message needsclick" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-up text-primary fs-3x" }),
  /*#__PURE__*/_createElementVNode("div", { class: "ms-4" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fs-5 fw-bolder text-gray-900 mb-1" }, " Drop your Dispute notification here. "),
    /*#__PURE__*/_createElementVNode("span", { class: "fs-7 fw-bold text-gray-400" }, "Uploads to your file directory")
  ])
], -1)
const _hoisted_82 = [
  _hoisted_81
]
const _hoisted_83 = { class: "modal-footer flex-center" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  class: "btn btn-white me-3"
}, "Discard", -1)
const _hoisted_85 = {
  ref: "submitButtonRef",
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_86 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Submit ", -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_88 = [
  _hoisted_86,
  _hoisted_87
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          class: "form",
          onSubmit: _ctx.submit,
          "validation-schema": _ctx.validationSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("h4", _hoisted_14, _toDisplayString(_ctx.merchant.dba_name), 1),
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("a", null, _toDisplayString(_ctx.merchant.mid_number), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.chargeback.dispute_date,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.chargeback.dispute_date) = $event)),
                      name: "dispute_date",
                      "value-format": "YYYY-MM-DD"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.chargeback.notice_date,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.chargeback.notice_date) = $event)),
                      name: "notice_date",
                      "value-format": "YYYY-MM-DD"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.chargeback.expire_date,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.chargeback.expire_date) = $event)),
                      name: "expire_date",
                      "value-format": "YYYY-MM-DD"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.chargeback.transaction_date,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.chargeback.transaction_date) = $event)),
                      name: "transaction_date",
                      "value-format": "YYYY-MM-DD"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode(_component_Field, {
                      class: "form-control form-control-solid",
                      placeholder: "",
                      name: "case_number",
                      modelValue: _ctx.chargeback.case_number,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.chargeback.case_number) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_ErrorMessage, { name: "case_number" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode(_component_Field, {
                      class: "form-control form-control-solid",
                      placeholder: "",
                      name: "arn",
                      modelValue: _ctx.chargeback.arn,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.chargeback.arn) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_ErrorMessage, { name: "arn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createVNode(_component_Field, {
                      name: "card_brand",
                      class: "form-select form-select-solid select2-hidden-accessible",
                      placeholder: "Card Brand",
                      as: "select",
                      modelValue: _ctx.chargeback.card.brand,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.chargeback.card.brand) = $event))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_38,
                        _hoisted_39,
                        _hoisted_40,
                        _hoisted_41
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      class: "fv-plugins-message-container invalid-feedback",
                      name: "card_brand"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "",
                      name: "card_bin",
                      modelValue: _ctx.chargeback.card.bin,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.chargeback.card.bin) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createVNode(_component_ErrorMessage, { name: "card_bin" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "",
                      name: "card_last",
                      modelValue: _ctx.chargeback.card.last,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.chargeback.card.last) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createVNode(_component_ErrorMessage, { name: "card_last" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "$",
                      name: "dispute_amount",
                      modelValue: _ctx.chargeback.dispute_amount,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.chargeback.dispute_amount) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _createVNode(_component_ErrorMessage, { name: "dispute_amount" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "$",
                      name: "settled_amount",
                      modelValue: _ctx.chargeback.settled_amount,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.chargeback.settled_amount) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createVNode(_component_ErrorMessage, { name: "settled_amount" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "",
                      name: "reason",
                      modelValue: _ctx.chargeback.reason,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.chargeback.reason) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_ErrorMessage, { name: "reason" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _hoisted_65,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "",
                      name: "auth_code",
                      modelValue: _ctx.chargeback.auth_code,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.chargeback.auth_code) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("div", _hoisted_67, [
                        _createVNode(_component_ErrorMessage, { name: "auth_code" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _hoisted_69,
                    _createVNode(_component_Field, {
                      class: "form-control form-control-solid",
                      placeholder: "",
                      name: "reference_id",
                      modelValue: _ctx.chargeback.reference_id,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.chargeback.reference_id) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _createVNode(_component_ErrorMessage, { name: "reference_id" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _hoisted_74,
                    _createElementVNode("label", _hoisted_75, [
                      _createVNode(_component_Field, {
                        class: "form-check-input",
                        name: "escalated",
                        type: "checkbox",
                        value: "1",
                        checked: "checked",
                        modelValue: _ctx.chargeback.escalated,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.chargeback.escalated) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                          _createVNode(_component_ErrorMessage, { name: "escalated" })
                        ])
                      ]),
                      _hoisted_78
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("div", _hoisted_80, _hoisted_82, 512)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_83, [
              _hoisted_84,
              _createElementVNode("button", _hoisted_85, _hoisted_88, 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ], 512))
}